<template>
	<div style="position: relative;">

		<el-image style="height: 100vh;width: 100vw;position: absolute;z-index: 0;top: 0;left: 0;" fit="cover"
			:src="detailInfo.backFile"></el-image>

		<div style=" position: absolute;
		    z-index: 2;
		    inset: 0;">
			<div class="page-title">
				<div style="padding-top:2%;">
					道佑判例
					<img src="../assets/images/home_TitleLine.png" />
				</div>
			</div>
			<div style="width:85%;margin:0 auto;margin-top:33vh;">
				<!-- <div style="font-size: 2.9vw;color: #000000;text-align: left;font-weight: 500;">
					{{detailInfo.title}}
				</div> -->
				<!-- <div style="font-size: 2.3vw;color: #000000;text-align: left;margin-top: 1vh;font-weight: 500;">
					涵盖常见交通事故类型
				</div> -->
			<!-- 	<div style="display: flex;">
					<div v-for="item in plTitle"
						style="color: #fff;background-color: #3B6DC8;border-radius: 3px;text-align: center;font-size: 1.4vw;margin-top: 1vh;margin-left: 5px;padding: 0.3vw 0.9vw;">
						{{ item.title }}
					</div>
				</div> -->
				<div style="text-align: left;width: 43%;margin-top: 1vh;" v-html="detailInfo.summaryContent"
					class="html10"> </div>

				<div @click="gotoPanLi"
					style="cursor: pointer; background: linear-gradient(to bottom, #DFE3EB, #9D9FA5);width: 14.7vw;height: 4.6vw;color: #fff;font-size: 18px;font-weight: bolder;line-height: 46px;margin-top: 10vh;display: flex;flex-direction: row;align-items: center;justify-content: center;">
					<i class="el-icon-arrow-right" style="1.8vw"></i> 点 击 查 询
				</div>
			</div>

		</div>
		<!-- </div> -->




	</div>

</template>

<script>
	import {
		summaryList
	} from '@/api/webstation.js'
	export default {
		name: 'homeOne',
		components: {

		},
		data() {
			return {
				detailInfo: {},
				plTitle: [{
						title: "实践丰富"
					},
					{
						title: "理论深刻"
					},
					{
						title: "实际可用"
					}
				]
			}

		},
		created() {
			this.getsummaryList()

		},
		methods: {
			gotoPanLi() {
				let isLogin = localStorage.getItem('loginToken') ? true : false
				if (!isLogin) {
					this.$router.replace('/login')
				} else {
					this.$router.push('/dyPanli')
				}
			},
			getsummaryList() {
				let that = this
				summaryList({
					"pageNum": "1",
					"pageSize": "1",
					"showModel": '2'
				}).then(res => {
					if (res.code == 200) {
						that.detailInfo = res.rows[0]
						console.log('that.detailInfo: ', that.detailInfo);
					}
				})
			}

		}
	}
</script>

<style scoped>
	@import '../assets/home.css';

	.html10 /deep/ p {
		width: 100%;
	}
	.html10 /deep/ p img {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/home_six.vue